import styled from "styled-components";

export const StyledTabs = styled.div`
  margin-bottom: 1.5rem;
  border-bottom: 0.1rem solid #e1e3e5;
  // .Polaris-Tabs__TabContainer:first-child .Polaris-Tabs__Tab {
  //   padding-left: 1.4rem;
  // }
`;

export const StyledTabsAdvanceShipping = styled.div`
  margin-bottom: 0.5rem;
  border-bottom: 0.1rem solid #e1e3e5;
`;
